// MF-566 — Card 'kpi-bar': one big number with a bar under it (Belmont dashboard KPIs). The bar
// fills value / options.barMax; with options.split it shows two shares instead (positive vs
// negative) and the value gets a ▲/▼ for its sign.
import { Box, Typography } from '@mui/material'
import { SUMMARY_PALETTE, toneColor } from '../../../Dashboard/StudentSummary/summary.palette'
import { fmtValue } from '../boardTheme'

const TRACK = '#dfe3e8'

const Bar = ({ parts }) => (
  <Box
    sx={{ display: 'flex', height: 10, borderRadius: 5, overflow: 'hidden', bgcolor: TRACK, width: '100%' }}
  >
    {parts.map((p) => (
      <Box key={p.color} sx={{ width: `${p.pct}%`, bgcolor: p.color, transition: 'width .4s' }} />
    ))}
  </Box>
)

const KpiBarCard = ({ data }) => {
  const row = data?.rows?.[0] || {}
  const field = data?.encoding?.fields?.[0] || {}
  const options = data?.meta?.card?.options || {}
  const color = toneColor(options.tone)
  const value = Number(row[field.key])

  let parts = []
  if (options.split) {
    const pos = Number(row.positive) || 0
    const neg = Number(row.negative) || 0
    const total = pos + neg
    parts =
      total > 0
        ? [
            { color: SUMMARY_PALETTE.good, pct: (pos / total) * 100 },
            { color: SUMMARY_PALETTE.bad, pct: (neg / total) * 100 }
          ]
        : []
  } else if (options.barMax > 0 && Number.isFinite(value)) {
    parts = [{ color, pct: Math.max(0, Math.min(100, (value / options.barMax) * 100)) }]
  }

  const arrow = options.arrow && Number.isFinite(value) && value !== 0 ? (value > 0 ? '▲' : '▼') : ''
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 1.5,
        height: '100%',
        px: 0.5,
        pb: 1
      }}
    >
      <Typography sx={{ fontSize: 40, fontWeight: 700, lineHeight: 1, color }}>
        {arrow ? <span style={{ fontSize: 28, marginRight: 4 }}>{arrow}</span> : null}
        {fmtValue(Number.isFinite(value) ? Math.abs(value) : null, options.decimals || 0)}
        {field.unit || ''}
      </Typography>
      {parts.length ? <Bar parts={parts} /> : null}
    </Box>
  )
}

export default KpiBarCard
